import Cloudsearch from './cloudsearch';
import Analytics from './analytics';
import { DateTime } from 'luxon';
import * as DOMPurify from 'dompurify';
const Handlebars = require('handlebars');

class Research extends Cloudsearch {
  constructor() {
    super();

    //Sample code, delete if works
    //this.showPagination( 0 );
    this.size = 5;
    this.topic = 'thesaurus';
    this.fq = "(and topic:'" + this.topic + "')";
    this.default_fq = {
      topic: this.topic,
      //content_language: document.querySelector('html').getAttribute('lang').split('-')[0],
    };
    this.previewSize = 25;
    this.filterTimer = 0;
    this.controller = null;

    this.setupEvents();
    this.setupAdvancedFields();
  }

  showResearchInfo(event) {
    //console.log('inside the class', event.target);
    let text_to_search = event.currentTarget.querySelector('a').innerText;
    //document.querySelector('')
    let predictiveText = document.querySelector('#research_predictiveText');
    predictiveText.querySelector('.predictiveText__menu').blur();
    //this.word = text_to_search;
    predictiveText.querySelector('input').value = text_to_search;
    predictiveText.querySelector('input').setAttribute('value', text_to_search);
    predictiveText.querySelector('button').click();
  }

  async predictiveSearchTerms(word) {
    let coincidences = [];
    if (document.querySelector('.research') != null) {

      let search_data = {
        arr_return_vars: ["keywords"],
        keyword: word,
        size: this.previewSize,
        start: 0,
        options: "{fields:['keywords^5']}",
        fq: `(and topic:'${this.topic}' (prefix field=keywords '${word.trim()}'))`,
        sort: '_score desc',
        parser: "lucene",
      };

      if( this.controller != null ) {
        this.controller.abort();
      }
      this.controller = new AbortController();

      let search_options = {
        //mode: 'no-cors'
        signal: this.controller.signal,
      };

      if ( location.host == this.prod_hosts[0] || location.host == this.sandbox_hosts[0] ) {
        search_options.headers = this.openweb_header;
      }

      return fetch(this.parseSearchUrl(search_data), search_options)
        .then(response => response.json())
        .then(result => {
          if (result.data.hits != undefined) {
            if (result.data.hits.found > 0) {
              let matches = [];
              result.data.hits.hit.forEach(hit => {
                if( hit.fields !== undefined ) {
                  /**
                   * OpenWeb's search engine is not working correctly and it's searching
                   * on title and content even though the requests only sets keywords field
                   * We have to filter results containing only the requested keyword
                   */
                  hit.fields.keywords = hit.fields.keywords.filter(v => v.toLowerCase().includes(word.toLowerCase()));
                  hit.fields.keywords.forEach(keyword => {
                    matches.push(keyword);
                  });
                }
              });
              matches = [...new Set(matches)].sort((a,b) => a.localeCompare(b));
              matches.forEach(keyword => {
                coincidences.push({
                  link: '#',
                  text: keyword,
                });
              });
              return coincidences;
            } else {
              coincidences.push({
                link: '#', text: 'No se encontraron coincidencias',
              });
              return coincidences;
            }
          }
        })
        .catch(function (err) {
          console.log("Error on fetch", err);
          coincidences.push({
            link: '#', text: 'No se encontraron coincidencias',
          });
          return coincidences;
        });
    }
  }

  setupEvents() {
    document.addEventListener("DOMContentLoaded", () => {
      //Set First Level Menu click event on Research Link
      if( null != document.querySelector('.research-menu-link') ) {
        document.querySelector('.research-menu-link').addEventListener('click', () => {
          this.setAnalyticsData( {
            action: 'link',
            event_name: 'research_menu_link',
          });
        });
      }

      document.querySelectorAll('[href*="/research"]').forEach(link => {
        //exclude canonicals & .research-menu-link
        if( ! (link.hasAttribute('hreflang') || link.closest('.navigation') != null || link.parentElement.querySelector('.research-menu-link') != null ) ) {
          link.addEventListener('click', () => {
            this.setAnalyticsData( {
              action: 'link',
              event_name: 'research_more_link',
            });
          });
        }
      })


      if( null !== document.querySelector('.research__results') ) {
        this.showLatestResearchView();
      }

      //Check if url params exist
      const params = this.getAllUrlParams()
      if( Object.entries(params).length && params.q !== null && null !== document.querySelector('#research_predictiveText .search-btn')) {
        this.paramsSearch(params);
      }
    });

    if( null !== document.querySelector('#research_predictiveText .search-btn') ) {
      document.querySelector('#research_predictiveText input').addEventListener('focus', () => {
        this.setAnalyticsData({
          action: 'interaction',
          event_name: 'search_input',
          interaction_data: 'clic en campo buscador basico',
        });
      });

      document.querySelector('#research_predictiveText .search-btn').addEventListener('click', () => {
        let search_input = document.querySelector('#research_predictiveText input');
        this.word = DOMPurify.sanitize(search_input.getAttribute('value') != undefined?search_input.getAttribute('value'):'');
        //window.history.pushState('search', 'New search', window.location.origin + window.location.pathname + '?q=' + encodeURIComponent(this.word));
        search_input.blur();
        //document.querySelector('.research__results').scrollIntoView({behavior: 'smooth'});
        window.scroll({
          top: 400,
          behavior: 'smooth',
        });
        if( this.word.length === 0 ) {
          this.setAnalyticsData({
            action: 'link',
            event_name: 'search_button',
            link_data: { name: 'clic buscador basico con campo de texto vacio' },
          });
        }
        this.applyFilter(false);
        this.querySearch({searchWordPrefix: 'buscador basico'});
      });
    }

    if( null != document.querySelector('.research__advanced_link') ) {
      document.querySelector('.research__advanced_link').addEventListener('click', (e) => {
        e.preventDefault();
        this.clearSearch();
        this.showAdvancedSearchView();
        e.currentTarget.classList.toggle('research__advanced_link--hidden');
        document.querySelector('.research__latest_link').classList.toggle('research__latest_link--hidden');
        this.setAnalyticsData( {
          action:'view',
          event_name: 'advanced_link',
        });

        let text_language = document.querySelector('html').getAttribute('lang').split('-')[0];
        let pagename = text_language == 'es' ? 'busqueda avanzada' : 'advanced search';
        this.setAnalyticsData( {
          action: 'link',
          event_name: 'advanced_link',
          link_data: { name:  pagename},
        });
        e.stopPropagation();
      });

      //Interaction with multiple select dropdown
      document.querySelector(`input[name="adv_country"]`)
        .parentElement
        .querySelector('.dropdown__continue button')
        .addEventListener('click', () => {
        let value = Analytics.parseText(document.querySelector(`input[name="adv_country"]`)
          .getAttribute('value'));
        this.setAnalyticsData({
          action: 'interaction',
          event_name: 'adv_country_button',
          interaction_data: `filtro busqueda avanzada:country:${value}`,
        });
      });
    }

    /**
     * Show/Hide filters on mobile
     */
    if (screen.width < 960 && null !== document.querySelector('.research__card') ) {
      document.querySelector('.research__card').classList.toggle('research__card-mobile');
    }

    if( null != document.querySelector('.research__filters-mobile a') ) {
      document.querySelector('.research__filters-mobile a').addEventListener('click', (event) => {
        event.preventDefault();
        document.querySelector('.research__card').classList.toggle('research__card-mobile');
      });
    }

    window.addEventListener('resize', () => {
      if (screen.width < 960 && null !== document.querySelector('.research__card') ) {
        document.querySelector('.research__card').classList.toggle('research__card-mobile');
      }
    });

    /**
     * Filters events
     */
    let checkboxes = ['country', 'methodology', 'date', 'research_type', 'profile'];
    let selectors = checkboxes.map(keyword => '.research__filters input[name="' + keyword + '"]').join(',');
    document.querySelectorAll(selectors).forEach(checkbox => {
      let selector_category = checkbox.getAttribute('name');
      let checkbox_value = Analytics.parseText(checkbox.getAttribute('value'));
      checkbox.addEventListener('click', () => {
        this.setAnalyticsData({
          action: 'interaction',
          event_name: 'apply_filter',
          interaction_data: `filtro pagina resultados:${selector_category}:${checkbox_value}`,
        });
      });
      checkbox.addEventListener('click', this.applyFilter.bind(this));
    });

    //Reset filters button
    if( null !== document.querySelector('.research__filters .reset-filters') ){
      document.querySelector('.research__filters .reset-filters').addEventListener('click', (event) => {
        event.preventDefault();
        let checked_selectors = checkboxes.map(keyword => '.research__filters input[name="' + keyword + '"]:checked').join(',');
        document.querySelectorAll(checked_selectors).forEach(checkbox => {
          checkbox.checked = false;
        });

        if( checked_selectors.length ) {
          this.applyFilter();
        }
        this.setAnalyticsData({
          action: 'interaction',
          event_name: 'reset_filters',
          interaction_data: 'limpiar filtros',
        });
        event.stopPropagation();
      });
    }

    /**
     * Advanced Search
     */
    if( null !== document.querySelector('.research__advanced .textfield') ) {
      let enterkey = 13;
      document.querySelector('.research__advanced .textfield').addEventListener('keyup', event => {
        let code = (event.keyCode ? event.keyCode : event.which);
        //Enter keyCode
        if ( code == enterkey ) {
          document.querySelector('.research__advanced a.button.button--primary').click();
        }
      });
    }

    if( null !== document.querySelector('.research__advanced a.button.button--primary') ){
      document.querySelector('.research__advanced a.button.button--primary').addEventListener('click', (event) => {
        event.preventDefault();
        this.advancedSearch();
      });
    }

    /**
     * Latest Research link
     */
    if( null !== document.querySelector('.research__latest_link') ) {
      document.querySelector('.research__latest_link').classList.toggle('research__latest_link--hidden');
      document.querySelector('.research__latest_link').addEventListener('click', (e) => {
        e.preventDefault();
        this.clearSearch();
        this.showLatestResearchView();
        e.currentTarget.classList.toggle('research__latest_link--hidden');
        document.querySelector('.research__advanced_link').classList.toggle('research__advanced_link--hidden');
        this.setAnalyticsData({
          event_name: 'latest_publications',
        }, true);
        e.stopPropagation();
      });
    }

    /**
     * Latest Research (archive)
     */
    if( null !== document.querySelector('.research__latest-research') ) {
      document.querySelectorAll('.research__latest-research .links').forEach(link => {
        link.addEventListener('click', () => {
          let extension = /\/presentation\//.test(link.getAttribute('href')) ? 'ppt' : 'pdf';
          const [aux1, aux2] = link.parentElement.previousElementSibling.innerText.split(' ');
          this.setAnalyticsData( {
            action: 'external_link',
            event_name: 'search_result_link',
            link_data: {
              url: link.getAttribute('href'),
              name: Analytics.parseText(link.innerText),
              ext: extension,
              aux1: aux1,
              aux2: aux2,
              aux3: '',
            },
          });
        });
      });
    }


  }

  /* setupOnChangeAdvanced() {
    //Interaction with normal dropdowns
    let dd_names = ['date', 'research_type', 'methodology', 'profile'];
    dd_names.forEach( item => {
      let dd_name = `adv_${item}`;
      let dd = document.querySelector(`input[name="${dd_name}"]`);
      if( dd != null ) {
        let value = Analytics.parseText(dd.getAttribute('value'));
        this.setAnalyticsData({
          action: 'interaction',
          event_name: dd_name,
          interaction_data: `filtro busqueda avanzada:${item}:${value}`,
        });
      }
    });
  } */

  setupPaginationEvents() {
    /**
     * Pagination Events
     */
    document.querySelectorAll('.pagination__number:not(.pagination__number--current)').forEach(element => {
      element.addEventListener('click', this.queryPage.bind(this));
    });

    document.querySelectorAll('.pagination__symbol').forEach(element => {
      element.addEventListener('click', this.queryPage.bind(this));
    });
  }

  setupAdvancedFields() {

    document.addEventListener("DOMContentLoaded", () => {
      //Get all fields elements from the filter section
      let checkboxes = ['country', 'methodology', 'date', 'research_type', 'profile'];
      let dd_item_tpl = Handlebars.compile(`<div class="item" data-dropdown-value="{{value}}">{{title}}</div>`);
      //let selectors = checkboxes.map(keyword => '.research__filters input[name="' + keyword + '"]').join(',');
      checkboxes.forEach( checkbox_group => {
        if( null !== document.querySelector(`input[name="adv_${checkbox_group}"]`) ) {
          let dd = document.querySelector(`input[name="adv_${checkbox_group}"]`).parentNode;
          [...dd.querySelectorAll('.item:not(.item--select-all)')].forEach(item => item.remove());
          [...document.querySelectorAll(`.research__filters input[name="${checkbox_group}"]`)].forEach(checkbox => {
            let new_item = dd_item_tpl({title: checkbox.getAttribute('value'), value: checkbox.getAttribute('value')});
            dd.querySelector('.dropdown__menu').innerHTML += new_item;
          });
          let dd_instance = window.ExperienceTheme.dropdowns.get(dd);
          if( dd_instance.dropdownIsMultiple() ) {
            dd_instance.allItems = [...dd.querySelector('.dropdown__menu').children];
          }
          dd_instance.dropdownDataUpdate();
        }
      });

      let dd_names = ['date', 'research_type', 'methodology', 'profile'];
      dd_names.forEach( item => {
        let dd_name = `adv_${item}`;
        let dd_element = document.querySelector(`input[name="${dd_name}"]`);
        if( null != dd_element ) {
          dd_element
            .parentElement
            .querySelectorAll('.item')
            .forEach(dd_item => {
              dd_item.addEventListener('mousedown', () => {
                let value = Analytics.parseText(document.querySelector(`input[name="${dd_name}"]`).getAttribute('value'));
                this.setAnalyticsData({
                  action: 'interaction',
                  event_name: dd_name,
                  interaction_data: `filtro busqueda avanzada:${item}:${value}`,
                });
              });
            });
        }
      });

      let keyword_name = 'adv_keywords';
      let keyword_element = document.querySelector(`input[name="${keyword_name}"]`);
      if( null != keyword_element ) {
        keyword_element.addEventListener('blur', () => {
          let value = DOMPurify.sanitize(Analytics.parseText(keyword_element.getAttribute('value')));
          if( value.length > 0 ) {
            this.setAnalyticsData({
              action: 'interaction',
              event_name: keyword_name,
              interaction_data: `filtro busqueda avanzada:${keyword_name}:${value}`,
            });
          }
        });
      }
    });
  }

  onSubmit() {
    document.querySelector('#research_predictiveText .search-btn').click();
  }

  querySearch(data = {}) {
    //if (document.querySelector('.research') != null && this.word != "undefined" ) {
    if (document.querySelector('.research') != null && this.fq.length ) {
      this.clearResults();
      this.showSearchResultsView();
      this.showSpinner();
      let search_data = {
        arr_return_vars: [
          "title",
          "resourcename",
          "description",
          "domain",
          "keywords",
          "image_src",
          "topic",
          "category",
          "date",
          "wp_text",
          "wp_double",
          "wp_text_array",
          "wp_double_array",
          "_score",
          "content_language",
        ],
        size: this.size,
        start: this.start != null? parseInt(this.start) : (this.current_page - 1) * this.size,
        options: "{fields:['title^5', 'topic^4', 'category^3', 'description^2']}",
        fq: this.fq,
        sort: '_score desc',
        parser: "lucene",
      };

      if (this.word != undefined && this.word != 'undefined') {
        search_data.keyword = this.word;
      }

      //Used to encode and append to url and browser history
      let search_data_url_obj = {
        start: search_data.start,
        fq: search_data.fq,
        q: this.word,
      };
      let search_data_url = decodeURI(new URLSearchParams(search_data_url_obj).toString().replace(/\+/g, ' '));

      let search_options = {
        //mode: 'no-cors'
      };

      if ( location.host == this.prod_hosts[0] || location.host == this.sandbox_hosts[0] ) {
        search_options.headers = this.openweb_header;
      }

      fetch(this.parseSearchUrl(search_data), search_options)
        .then(response => response.json())
        .then(result => {
          //console.log(result);
          this.hideSpinner();
          let num_results = "0";
          if (result.data.hits != undefined) {
            //document.querySelector("#count").innerHTML = result.data.hits.found;
            if (result.data.hits.found > 0) {
              this.renderResults(result.data.hits.hit);
              this.renderPagination(result.data.hits.found);
              num_results = '' + result.data.hits.found;
            } else {
              this.showEmptyState();
              this.hideSearchResultsFooterView();
              document.querySelector('.research-results').innerHTML = '';
            }
          }

          if( this.current_page === 1 ) {
            let enterTerm = data.searchWordPrefix != undefined ? `${data.searchWordPrefix}:${this.word}` : this.word;
            this.addTaggingInfo(this.word, enterTerm, num_results);
          } else {
            this.removeTaggingInfo();
          }
          this.setAnalyticsData({
            action: 'view',
            event_name: 'search_results',
          },
          true );
          window.ExperienceTheme.analytics.addIfCookiesEnabled();
          window.history.pushState('search', 'New search', window.location.origin + window.location.pathname + '?' + search_data_url);
        })
        .catch( err => {
          console.log("Error on fetch", err);
          window.history.pushState('search', 'New search', window.location.origin + window.location.pathname + '?' + search_data_url);
        });
    }
  }

  clearSearch() {
    document.querySelector('#research_predictiveText .clear-btn').click();
  }

  clearResults() {
    let results_container = document.querySelector('.research-results')
    results_container.innerHTML = '';
    results_container.scrollIntoView({behavior: 'smooth'});
    this.hidePagination();
  }

  renderResults(items = []) {
    let text_language = document.querySelector('html').getAttribute('lang').split('-')[0];
    const result_tpl = `<div class="card">
        <div class="card__editorial card__editorial--main">
            <div class="card__desc">
                <div class="content-title mobile-title">
                    <p class="grey600 result__right content-date">{{date}}</p>
                    <h6>
                        <a href="{{url}}" target="_blank" class="links" title="{{title}}">{{title}}</a>
                    </h6>
                </div>
                <div class="content-description">
                    <p class="body-copy ">{{description}}</p>
                </div>
                <div class="content-list">
                    <p class="body-copy result__label">{{country_label}}:
                        <span class="grey600">{{ country }}</span>
                    </p>
                    <p class="body-copy result__label">{{ profile_label }}:
                        <span class="grey600">{{ profile }}</span>
                    </p>
                    <p class="body-copy result__label">{{ research_type_label }}:
                        <span class="grey600">{{ research_type }}</span>
                    </p>
                    <p class="body-copy result__label">{{ methodology_label }}:
                        <span class="grey600">{{ methodology }}</span>
                    </p>
                </div>
                <div class="content-tags">{{{ keywords }}}</div>
            </div>
        </div>
    </div>`;

    let template = Handlebars.compile(result_tpl);
    let tag_prefix = '<span class="tag">';
    let tag_suffix = '</span>';

    let all_results = '';
    items.forEach(item => {
      let wp_text = JSON.parse(item.fields.wp_text);
      let profiles = wp_text.profiles;
      //let contacts = wp_text.contacts;

      let data = {
        url: item.fields.resourcename != undefined ? item.fields.resourcename : '',
        title: item.fields.title != undefined ? item.fields.title : '',
        //title_ref: item.fields.title != undefined ? item.fields.title : '',
        date: item.fields.date != undefined ? this.parseDate(item.fields.date, text_language) : '',
        description: item.fields.content != undefined ? item.fields.content : '',
        country_label: text_language == 'es'?'País':'Country',
        country: item.fields.category != undefined ? item.fields.category : '',
        profile_label: text_language == 'es'?'Perfil':'Profile',
        profile: profiles.join(', ').replace('&amp;', '&'),
        research_type_label: text_language == 'es'?'Tipo de Investigación':'Research Type',
        research_type: item.fields.wp_text_array != undefined ? item.fields.wp_text_array.join(', ') : '',
        methodology_label: text_language == 'es'?'Metodología':'Methodology',
        methodology: item.fields.description != undefined ? item.fields.description : '',
        keywords: item.fields.keywords != undefined ? item.fields.keywords.map(keyword => tag_prefix + keyword + tag_suffix).join('') : '',
      };

      //for some reason, url is coming with https:/ instead of https://
      data.url = data.url.replace(/(https:\/)([aA-zZ])(.*)/, "$1/$2$3");

      let result = template(data);
      all_results += result;
    });

    let container = document.querySelector('.research-results');
    container.innerHTML = all_results;
    this.setResultsEvents();
  }

  parseDate(date, locale) {
    let parsedDate = DateTime.fromISO(date).setLocale(locale).toFormat('LLLL y');
    return parsedDate;
  }

  showSpinner() {
    document.querySelector('.spinner').classList.add('spinner--active');
  }

  hideSpinner() {
    document.querySelector('.spinner').classList.remove('spinner--active');
  }

  showEmptyState() {
    document.querySelector('.card-empty-state').classList.add('card-empty-state--active');
  }

  hideEmptyState() {
    document.querySelector('.card-empty-state').classList.remove('card-empty-state--active');
  }

  showPagination() {
    document.querySelector('.pagination').classList.add('pagination--show');
  }

  hidePagination() {
    document.querySelector('.pagination').classList.remove('pagination--show');
  }

  showLatestResearchView() {
    this.hideAdvancedSearchView();
    this.hideSearchResultsView();
    this.hideSearchResultsFooterView();

    document.querySelector('.research__latest-research').classList.remove('hide');
  }

  hideLatestResearchView() {
    document.querySelector('.research__latest-research').classList.add('hide');
  }

  showSearchResultsView() {
    this.hideEmptyState();
    this.hideLatestResearchView();
    this.hideAdvancedSearchView();
    this.showSearchResultsFooterView();
    document.querySelector('.research__results').classList.remove('hide');
  }

  hideSearchResultsView() {
    document.querySelector('.research__results').classList.add('hide');
  }

  showSearchResultsFooterView() {
    document.querySelector('.research__results--footer').classList.remove('hide');
  }

  hideSearchResultsFooterView() {
    document.querySelector('.research__results--footer').classList.add('hide');
  }

  showAdvancedSearchView() {
    this.hideLatestResearchView();
    this.hideSearchResultsView();
    this.hideSearchResultsFooterView();
    document.querySelector('.research__advanced').classList.remove('hide');
  }

  hideAdvancedSearchView() {
    document.querySelector('.research__advanced').classList.add('hide');
  }

  renderPagination(total = 0) {
    if (total === 0) {
      this.showEmptyState();
      this.hideSearchResultsFooterView();
    } else {
      this.hideEmptyState();
      this.showSearchResultsFooterView();
    }

    let text_language = document.querySelector('html').getAttribute('lang').split('-')[0];
    let previous_label = text_language=='es'?'Anterior':'Previous';
    let next_label = text_language=='es'?'Siguiente':'Next';
    let showing_label = text_language=='es'?'Mostrando':'Showing';
    let of_label = text_language=='es'?'de':'of';
    let results_label = text_language=='es'?'resultados':'results';
    let info = `${showing_label} ${this.size} ${of_label} ${total} ${results_label}`;

    let first = `<a class="pagination__symbol pagination__symbol--first ui-first" href="#"></a>`;
    let prev = Handlebars.compile(`<a class="pagination__symbol pagination__symbol--prev ui-back" href="#" title="{{ previous }}"></a>`);
    let next = Handlebars.compile(`<a class="pagination__symbol pagination__symbol--next ui-next" href="#" title="{{ next }}"></a>`);
    let last = `<a class="pagination__symbol pagination__symbol--last ui-end" href="#"></a>`;

    this.num_pages = Math.ceil(total / this.size);

    let pagination_str = '';
    if (this.current_page < this.num_pages) {
      if (this.current_page > 1) {
        pagination_str += first + prev({previous: previous_label});
      }

      pagination_str += this.getPageItems(total);
      pagination_str += next({next: next_label}) + last;
    } else if( this.current_page === this.num_pages ) {
      pagination_str += this.getPageItems(total);
    } else {
      pagination_str += first + prev({previous: previous_label});
      pagination_str += this.getPageItems(total);
    }

    if( this.num_pages > 1 ) {
      this.showPagination();
      document.querySelector('.pagination__items').innerHTML = pagination_str;
      document.querySelector('.pagination__information').innerText = info;
      this.setupPaginationEvents();
    }
  }

  applyFilter( runQuery = true ) {
    //reset current_page
    this.current_page = 1;
    let date = '';
    let category = '';
    let description = '';
    let wp_text_array = '';
    let wp_text = '';
    //let fq = `topic:'${this.topic}' content_language:'${this.default_fq.content_language}' `;
    let fq = `topic:'${this.topic}' `;

    //Country -> Category
    let selected_country_nodes = document.querySelectorAll('input[name="country"]:checked');
    if(selected_country_nodes.length ) {
      if( selected_country_nodes.length === 1 ) {
        category = `${[...selected_country_nodes].map( country_node => "category:'" + country_node.value + "'" )}`;
      } else {
        category = `(or ${[...selected_country_nodes].map( country_node => "category:'" + country_node.value + "'" ).join(' ')})`;
      }
      fq += category + " ";
    }

    //Date
    let selected_date_nodes = document.querySelectorAll('input[name="date"]:checked');
    if(selected_date_nodes.length ) {
      if( selected_date_nodes.length === 1 ) {
        date = `${[...selected_date_nodes].map( date_node => "date:['" + date_node.value + "-01-01T00:00:00Z','" + date_node.value + "-12-31T23:59:59Z']" )}`;
      } else {
        date = `(or ${[...selected_date_nodes].map( date_node => "date:['" + date_node.value + "-01-01T00:00:00Z','" + date_node.value + "-12-31T23:59:59Z']" ).join(' ')})`;
      }
      fq += date + " ";
    }

    //Research Type -> wp_text_array
    let selected_research_type_nodes = document.querySelectorAll('input[name="research_type"]:checked');
    if( selected_research_type_nodes.length ) {
      if( selected_research_type_nodes.length === 1 ) {
        wp_text_array = `${[...selected_research_type_nodes].map( rt_node => "wp_text_array:'" + rt_node.value + "'" )}`;
      } else {
        wp_text_array = `(or ${[...selected_research_type_nodes].map( rt_node => "wp_text_array:'" + rt_node.value + "'" ).join(' ')})`;
      }
      fq += wp_text_array + " ";
    }

    //Methodology
    let selected_methodology_nodes = document.querySelectorAll('input[name="methodology"]:checked');
    if( selected_methodology_nodes.length ) {
      if( selected_methodology_nodes.length === 1 ) {
        description = `${[...selected_methodology_nodes].map( methodology_node => "description:'" + methodology_node.value + "'" )}`;
      } else {
        description = `(or ${[...selected_methodology_nodes].map( methodology_node => "description:'" + methodology_node.value + "'" ).join(' ')})`;
      }
      fq += description + " ";
    }

    //Profiles
    let selected_profile_nodes = document.querySelectorAll('input[name="profile"]:checked');
    if( selected_profile_nodes.length ) {
      if( selected_profile_nodes.length === 1 ) {
        wp_text = `${[...selected_profile_nodes].map( profile_node => "wp_text:'" + profile_node.value + "'" )}`;
      } else {
        wp_text = `(or ${[...selected_profile_nodes].map( profile_node => "wp_text:'" + profile_node.value + "'" ).join(' ')})`;
      }
      fq += wp_text + " ";
    }

    if (fq != '') {
      this.fq = "(and " + fq.replace('&', '%26') + " )";
    }

    //console.log(this.fq);
    if( runQuery ) {
      clearTimeout(this.filterTimer);
      this.filterTimer = setTimeout(()=> {
        this.querySearch();
      }, 3000);
    }
  }

  advancedSearch() {
    //reset current_page
    this.current_page = 1;
    let keywords = '';
    let date = '';
    let category = '';
    let description = '';
    let wp_text_array = '';
    let wp_text = '';
    //let fq = `topic:'${this.topic}' content_language:'${this.default_fq.content_language}' `;
    let fq = `topic:'${this.topic}' `;

    //Keyword
    let inserted_keywords = DOMPurify.sanitize(document.querySelector(`input[name="adv_keywords"]`).value);
    if( inserted_keywords.length ) {
      let arr_inserted_keywords = inserted_keywords.split(',');
      if( arr_inserted_keywords.length ) {
        if( arr_inserted_keywords.length === 1 ) {
          keywords = `${arr_inserted_keywords.map( keyword => "keywords:'" + keyword.trim() + "'" )}`;
        } else {
          keywords = `(or ${arr_inserted_keywords.map( keyword => "keywords:'" + keyword.trim() + "'" ).join(' ')})`;
        }
        fq += keywords + " ";

        //Copy inserted keywords to the search box
        let predictiveText = document.querySelector('#research_predictiveText');
        this.word = inserted_keywords;
        predictiveText.querySelector('input').value = inserted_keywords;
        window.ExperienceTheme.predictiveText.get(predictiveText).setValue(predictiveText.querySelector('input'));
        //predictiveText.querySelector('button').click();
      }
    }

    //Country -> Category
    let selected_countries = document.querySelector(`input[name="adv_country"]`).value.trim()
    if( selected_countries.length ) {
      selected_countries = selected_countries.split(',');
      if( selected_countries.length === 1 ) {
        category = `${selected_countries.map( country => "category:'" + country + "'" )}`;
      } else {
        category = `(or ${selected_countries.map( country => "category:'" + country + "'" ).join(' ')})`;
      }
      fq += category + " ";

      //Copy selected values to the corresponding filter
      [...document.querySelectorAll(`input[name="country"]`)].forEach( checkbox => {
        if( selected_countries.includes( checkbox.value ) ) {
          checkbox.checked = true;
        }
      });
    }

    //Date
    let selected_date = document.querySelector(`input[name="adv_date"]`).getAttribute('value');
    if( selected_date.length ) {
      //:['2000-01-01T00:00:00Z','2000-12-31T23:59:59Z'].
      date = `date:['${selected_date}-01-01T00:00:00Z','${selected_date}-12-31T23:59:59Z'] `;
      fq += date + " ";

      //Copy selected values to the corresponding filter
      [...document.querySelectorAll(`input[name="date"]`)].forEach( checkbox => {
        if( selected_date == checkbox.value ) {
          checkbox.checked = true;
        }
      });
    }

    //Research Type -> wp_text_array
    let selected_research_type = document.querySelector(`input[name="adv_research_type"]`).getAttribute('value');
    if( selected_research_type.length ) {
      wp_text_array = `wp_text_array:'${selected_research_type}' `;
      fq += wp_text_array + " ";

      //Copy selected values to the corresponding filter
      [...document.querySelectorAll(`input[name="research_type"]`)].forEach( checkbox => {
        if( selected_research_type == checkbox.value ) {
          checkbox.checked = true;
        }
      });
    }

    //Methodology
    let selected_methodology = document.querySelector(`input[name="adv_methodology"]`).getAttribute('value');
    if( selected_methodology.length ) {
      description = `description:'${selected_methodology}' `;
      fq += description + " ";

      //Copy selected values to the corresponding filter
      [...document.querySelectorAll(`input[name="methodology"]`)].forEach( checkbox => {
        if( selected_methodology == checkbox.value ) {
          checkbox.checked = true;
        }
      });
    }

    //Profiles experience_dd_225691131
    let selected_profile = document.querySelector(`input[name="adv_profile"]`).getAttribute('value');
    if( selected_profile.length ) {
      wp_text = `wp_text:'${selected_profile}' `;
      fq += wp_text + " ";

      //Copy selected values to the corresponding filter
      [...document.querySelectorAll(`input[name="methodology"]`)].forEach( checkbox => {
        if( selected_profile == checkbox.value ) {
          checkbox.checked = true;
        }
      });
    }

    if ( fq != '' ) {
      this.fq = "(and " + fq + " )";
    }

    //console.log(this.fq);
    this.querySearch();
    this.clearAdvancedSearchFields();
  }

  paramsSearch(params) {
    for (const [key, value] of Object.entries(params)) {
      this[key] = decodeURIComponent(value).replace('&', '%26');
    }
    //console.log(this)

    const text_to_search = decodeURIComponent(params.q);
    let predictiveText = document.querySelector('#research_predictiveText');
    predictiveText.querySelector('.predictiveText__menu').blur();
    predictiveText.querySelector('input').value = text_to_search;
    predictiveText.querySelector('input').setAttribute('value', text_to_search);

    //Analyze fq for filters
    let filters_regexp = /(category|wp_text_array|wp_text|description|date):('([a-zñ\s\-&]+)'|\['(\d{4}).*'\])/gi;
    let filters = filters_regexp.exec(this.fq.replace('%26', '&'));
    if( null != filters ) {
      let filters_obj = {};
      while (filters != null) {
        if( null == filters_obj[filters[1]] ) {
          filters_obj[filters[1]] = [];
        }
        //console.log('filters', filters)
        filters_obj[filters[1]].push(filters[1]!='date'?filters[3].replace('%26', '&'):filters[4]);
        filters = filters_regexp.exec(this.fq.replace('%26', '&'));
      }
      let checkboxes_map = {
        country: 'category',
        methodology: 'description',
        date: 'date',
        research_type: 'wp_text_array',
        profile: 'wp_text',
      };
      Object.entries(checkboxes_map).forEach(([field_name, search_field]) => {
        document.querySelectorAll(`input[name="${field_name}"]`).forEach(field => {
          if( filters_obj[search_field].includes(field.getAttribute('value')) ) {
            field.setAttribute('checked', 'checked');
          }
        });
      });
    }

    this.querySearch();
    if( this.start != null ) {
      delete this.start
    }
  }

  clearAdvancedSearchFields() {
    let adv_field_names = ['keywords', 'country', 'methodology', 'date', 'research_type', 'profile'];
    //let selectors = checkboxes.map(keyword => '.research__filters input[name="' + keyword + '"]').join(',');
    adv_field_names.forEach( adv_field_name => {
      let evaluated_field = document.querySelector(`input[name="adv_${adv_field_name}"]`);
      if( null !== evaluated_field ) {
        if( evaluated_field.classList.contains('textfield') ) {
          evaluated_field.parentElement.querySelector('.clear-btn').click();
        } else { //dropdowns
          evaluated_field.setAttribute('value', '');
          let dd = evaluated_field.parentNode;
          dd.querySelector('.dropdown__text').innerHTML = '';
          if( dd.querySelector('.dropdown__amount_selected') != undefined ) {
            dd.querySelector('.dropdown__amount_selected').innerHTML = '';
          }
          dd.querySelectorAll('.item').forEach(item => {
            item.classList.remove('selected');
          });
          let dd_instance = window.ExperienceTheme.dropdowns.get(dd);
          dd_instance.dropdownDataUpdate();
        }
      }
    });
  }

  setResultsEvents() {
    document.querySelectorAll('.research-results .links').forEach(link => {
      link.addEventListener('click', () => {
        let extension = /\/presentation\//.test(link.getAttribute('href')) ? 'ppt' : 'pdf';
        const [aux1, aux2] = link.parentElement.previousElementSibling.innerText.split(' ');
        this.setAnalyticsData( {
          action: 'external_link',
          event_name: 'search_result_link',
          link_data: {
            url: link.getAttribute('href'),
            name: Analytics.parseText(link.innerText),
            ext: extension,
            aux1: aux1,
            aux2: aux2,
            aux3: '',
          },
        });
      });
    });
  }

  setAnalyticsData( data, send = true ) {
    let text_language = document.querySelector('html').getAttribute('lang').split('-')[0];
    let previous_pageName = window.ExperienceTheme.analytics.getDigitalData().page.pageInfo.pageName;
    window.ExperienceTheme.analytics.setLinkInfo({});
    window.ExperienceTheme.analytics.setInteractionInfo({});
    window.ExperienceTheme.analytics.setLevel(3, '');
    window.ExperienceTheme.analytics.setLevel(4, '');
    window.ExperienceTheme.analytics.setPageName();

    switch(data.event_name) {
      case 'advanced_link':
        if( null == data.link_data ) {
          window.ExperienceTheme.analytics.setLevel(3, text_language == 'es' ? 'busqueda avanzada' : 'advanced search');
          window.ExperienceTheme.analytics.setPageName();
        } else {
          window.ExperienceTheme.analytics.digitalData.page.pageInfo.pageName = previous_pageName;
          window.ExperienceTheme.analytics.setLinkInfo(data.link_data);
        }
        break;
      case 'search_results':
        window.ExperienceTheme.analytics.setLevel(3, text_language == 'es' ? 'resultados de busqueda' : 'search results');
        if( this.current_page > 1 ) {
          window.ExperienceTheme.analytics.setLevel(4, `pagina ${this.current_page}`);
        }
        window.ExperienceTheme.analytics.setPageName();
        break;
      case 'research_menu_link':
        window.ExperienceTheme.analytics.setLinkInfo({name: 'investigaciones'});
        break;
      case 'research_more_link':
        window.ExperienceTheme.analytics.setLinkInfo({name: 'saber mas'});
        break;
      case 'search_result_link':
      case 'search_button':
        window.ExperienceTheme.analytics.digitalData.page.pageInfo.pageName = previous_pageName;
        window.ExperienceTheme.analytics.setLinkInfo(data.link_data);
        break;
      case 'reset_filters':
      case 'adv_keywords':
      case 'adv_country_button':
      case 'adv_date':
      case 'adv_research_type':
      case 'adv_methodology':
      case 'adv_profile':
      case 'search_input':
      case 'apply_filter':
        window.ExperienceTheme.analytics.setInteractionInfo(data.interaction_data);
        break;
      case 'latest_publications':
        window.ExperienceTheme.analytics.setLevel(3, text_language == 'es' ? 'ultimas investigaciones' : 'latest publications');
        window.ExperienceTheme.analytics.setPageName();
        break;
      default:
        break;
    }

    switch(data.action) {
      case 'external_link':
        window.digitalData = window.ExperienceTheme.analytics.getDigitalData();
        window.digitalLink('External Link', window.ExperienceTheme.analytics.getDigitalData());
        break;
      case 'link':
        window.digitalLink('Internal Link', window.ExperienceTheme.analytics.getDigitalData());
        break;
      case 'interaction':
        window.digitalLink('Interaction Link', window.ExperienceTheme.analytics.getDigitalData());
        break;
      default:
        if( send ) {
          window.digitalView('Page View', window.ExperienceTheme.analytics.getDigitalData());
        }
        break;
    }
  }
}

export default Research
